import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { ReasonForFailureService } from "./service/reason-for-failure.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-return-reason-for-failure",
  templateUrl: "./widget-return-reason-for-failure.component.html",
  styleUrls: ["./widget-return-reason-for-failure.component.scss"],
  providers: [ReasonForFailureService]
})
export class WidgetReturnReasonForFailureComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;

  dropdownItems = ["All"];
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  Alldata;

  constructor(
    private translateService: TranslateService,
    private dataService: ReasonForFailureService
  ) { }

  ngAfterViewInit() {
    this.getReasonForFailureData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getReasonForFailureData();
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.DELIVERY.REASON_FOR_FAILURE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getReasonForFailureData() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    this.dataService
      .getReasonForFailureData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData) {
            chartData.series.map(data => {
              this.dropdownItems.push(data[0]);
            });
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
            this.Alldata = chartData;
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  public dropdownChange(value: any): void {
    if (value !== "All") {
      const newCahrdata = { series: [], total: this.Alldata.total };
      const filter = this.Alldata.series.filter(data => data[0] === value);
      newCahrdata.series = filter;
      this.chartOptions = this.dataService.createChart(
        newCahrdata,
        this.OPTIONS
      );
    } else {
      this.chartOptions = this.dataService.createChart(
        this.Alldata,
        this.OPTIONS
      );
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
